var map = {
	"./australia.json": 201952,
	"./austria.json": 913589,
	"./belgium.json": 702215,
	"./canada.json": 762728,
	"./czech.json": 909673,
	"./denmark.json": 529192,
	"./finland.json": 340870,
	"./france.json": 985733,
	"./germany.json": 549431,
	"./ireland.json": 543249,
	"./israel.json": 812966,
	"./italy.json": 496497,
	"./netherlands.json": 607942,
	"./newzealand.json": 224553,
	"./norway.json": 558868,
	"./poland.json": 846174,
	"./slovakia.json": 898494,
	"./spain.json": 424283,
	"./sweden.json": 43362,
	"./switzerland.json": 613503,
	"./uk.json": 779674,
	"./usa.json": 123705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 335049;